import axios, { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { ScheduleOverride } from "../model/ScheduleOverride";
import { HttpClientError } from "../../../../providers/HttpClient";
import { invalidateAttendanceViews } from "./attendanceCache";

const ScheduleOverrideApiService = async (
  override: Partial<ScheduleOverride>
): Promise<ScheduleOverride> => {
  try {
    const { data } = await axios.post("/schedule-overrides/", override);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      HttpClientError(error);
      throw error;
    }
    throw error;
  }
};

const ApproveScheduleOverrideApiService = async (
  overrideId: string
): Promise<ScheduleOverride> => {
  try {
    const { data } = await axios.post(
      `/schedule-overrides/${overrideId}/approve/`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      HttpClientError(error);
    }
    throw error;
  }
};

const useCreateScheduleOverrideApiService = (): ReturnType<
  typeof useMutation<ScheduleOverride, AxiosError, Partial<ScheduleOverride>>
> => {
  const queryClient = useQueryClient();
  return useMutation<ScheduleOverride, AxiosError, Partial<ScheduleOverride>>(
    (override) => ScheduleOverrideApiService(override),
    {
      onSuccess: () => invalidateAttendanceViews(queryClient),
    }
  );
};

const useApproveScheduleOverrideApiService = (): ReturnType<
  typeof useMutation<ScheduleOverride, AxiosError, string>
> => {
  const queryClient = useQueryClient();
  return useMutation<ScheduleOverride, AxiosError, string>(
    (overrideId) => ApproveScheduleOverrideApiService(overrideId),
    {
      onSuccess: () => invalidateAttendanceViews(queryClient),
    }
  );
};

export {
  ScheduleOverrideApiService,
  ApproveScheduleOverrideApiService,
  useCreateScheduleOverrideApiService,
  useApproveScheduleOverrideApiService,
};
